import { render } from "./PdfAppointmentTable.vue?vue&type=template&id=12030ad4&scoped=true&ts=true"
import script from "./PdfAppointmentTable.vue?vue&type=script&lang=ts"
export * from "./PdfAppointmentTable.vue?vue&type=script&lang=ts"

import "./PdfAppointmentTable.vue?vue&type=style&index=0&id=12030ad4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12030ad4"]])

export default __exports__